import React, { useState } from 'react';

import { Stack, Text, createStyles, Button, Drawer } from '@mantine/core';
import { DatePickerInput, DatesRangeValue } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import { IconChevronDown } from '@tabler/icons-react';
import EventTypeMultiSelectAutoComplete, {
  IEventTypeMultiSelectAutoComplete,
} from 'components/form-fields/auto-complete-fields/EventTypeMultiSelectAutoComplete';
import { SearchFilters } from 'pages/private/owner/AthleteDetail/components/Attendance/types';

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content min-content',
    gridTemplateAreas: `'title title . filters'`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
  },
  filters: {
    gridArea: 'filters',
  },
  title: {
    gridArea: 'title',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.lg,
  },
  attendanceCard: {
    gridArea: 'attendanceCard',
    display: 'flex',
    width: 'fit-content',
    gap: theme.spacing.xl,
  },
  button: {
    width: 'min-content',
    marginLeft: 'auto',
  },
}));

interface IAthleteAttendanceFiltersProps {
  searchFilters: SearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<SearchFilters>>;
  initialSearchFiltersValue: SearchFilters;
  permission?: boolean;
  openTabsDrawer: () => void;
}

const AthleteAttendanceFilters = ({
  searchFilters,
  setSearchFilters,
  initialSearchFiltersValue,
  openTabsDrawer,
}: IAthleteAttendanceFiltersProps): JSX.Element => {
  const today = new Date();
  const { classes } = useStyles();
  const [isFiltersOpen, { open, close }] = useDisclosure(false);

  const [eventTypes, setEventTypes] = useState<IEventTypeMultiSelectAutoComplete[]>([]);

  const handleDateChange = (value: DatesRangeValue): void => {
    setSearchFilters(prev => ({ ...prev, date: value }));
  };
  const handleEventsChange = (values: IEventTypeMultiSelectAutoComplete[]): void => {
    setEventTypes(values);
    setSearchFilters(prev => ({ ...prev, events: values.map(v => v.eventTypeId) }));
  };

  const handleClearFilters = (): void => {
    setSearchFilters(initialSearchFiltersValue);
    setEventTypes([]);
  };

  return (
    <div className={classes.header}>
      <Text size='md' fw='bold' className={classes.title} onClick={openTabsDrawer}>
        Attendance
        <IconChevronDown size={16} style={{ marginLeft: 4 }} />
      </Text>
      <Button onClick={open} className={classes.filters} size='xs'>
        Filters
      </Button>
      <Drawer position='bottom' opened={isFiltersOpen} onClose={close}>
        <Stack spacing='sm' justify='flex-start'>
          <Button color='red' onClick={handleClearFilters} className={classes.button}>
            Clear Filters
          </Button>
          <DatePickerInput
            value={searchFilters.date}
            onChange={handleDateChange}
            valueFormat='YYYY MMM DD'
            type='range'
            allowSingleDateInRange
            clearable
            {...{ placeholder: 'Select date range' }}
            maxDate={today}
          />
          <EventTypeMultiSelectAutoComplete handleChange={handleEventsChange} values={eventTypes} />
        </Stack>
      </Drawer>
    </div>
  );
};

export default AthleteAttendanceFilters;
